import SFetch from '@app/utils/sfetch'

export default {
  // We extended this API call to optionally receive companyId, sometimes we want to make this call but currentCompanyid is not available on global variable(e.g.firm inbox).
  toggleTodoDone(id, currentCompanyId = Silverfin.currentCompanyId) {
    const url = Silverfin.Routes.toggle_done_remark_path(
      Silverfin.currentFirmId,
      currentCompanyId,
      id,
      { format: 'json' }
    )
    return SFetch.jsonWithAlert(url, { method: 'POST' })
  },

  // We extended this API call to optionally receive companyId, sometimes we want to make this call but currentCompanyid is not available on global variable(e.g.firm inbox).
  toggleFollow(id, currentCompanyId = Silverfin.currentCompanyId) {
    const url = Silverfin.Routes.toggle_follow_commentable_path(
      Silverfin.currentFirmId,
      currentCompanyId,
      id,
      { type: 'Remark', format: 'json' }
    )
    return SFetch.jsonWithAlert(url, { method: 'POST' })
  },

  setRemarkSticky(id, shouldBecomeSticky) {
    const url = Silverfin.Routes.remark_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      id,
      { component: { communication: true }, format: 'json' }
    )

    return SFetch.jsonWithAlert(url, {
      method: 'PATCH',
      body: {
        remark: { sticky: shouldBecomeSticky },
      },
    })
  },

  create(remarkParams) {
    const url = Silverfin.Routes.remarks_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      { format: 'json' }
    )
    return SFetch.json(url, {
      method: 'POST',
      body: { remark: remarkParams },
    })
  },

  // We extended this API call to optionally receive companyId, sometimes we want to make this call but currentCompanyid is not available on global variable(e.g.firm inbox).
  update(id, remarkParams, currentCompanyId = Silverfin.currentCompanyId) {
    const url = Silverfin.Routes.remark_path(
      Silverfin.currentFirmId,
      currentCompanyId,
      id,
      { format: 'json' }
    )
    return SFetch.json(url, {
      method: 'PATCH',
      body: {
        remark: remarkParams,
      },
    })
  },

  validateRecurringTodo(id, remarkParams, companyId) {
    const url = Silverfin.Routes.validate_recurring_todo_remark_path(
      Silverfin.currentFirmId,
      companyId,
      id,
      { format: 'json' }
    )
    return SFetch.json(url, {
      method: 'POST',
      body: {
        remark: remarkParams,
      },
    })
  },

  // We extended this API call to optionally receive companyId, sometimes we want to make this call but currentCompanyid is not available on global variable(e.g.firm inbox).
  destroy(
    id,
    currentCompanyId = Silverfin.currentCompanyId,
    periodScope = null
  ) {
    const url = Silverfin.Routes.remark_path(
      Silverfin.currentFirmId,
      currentCompanyId,
      id,
      { format: 'json', period_scope: periodScope }
    )
    return SFetch.jsonWithAlert(url, {
      method: 'DELETE',
    })
  },

  destroyOnwards(id, currentCompanyId = Silverfin.currentCompanyId) {
    const url = Silverfin.Routes.destroy_onwards_remark_path(
      Silverfin.currentFirmId,
      currentCompanyId,
      id,
      { format: 'json' }
    )
    return SFetch.jsonWithAlert(url, {
      method: 'DELETE',
    })
  },

  updatePastClientMeetingRemark(
    id,
    currentCompanyId = Silverfin.currentCompanyId
  ) {
    const url =
      Silverfin.Routes.client_meetings_past_remark_back_to_current_path(
        Silverfin.currentFirmId,
        currentCompanyId,
        id,
        { format: 'json' }
      )
    return SFetch.jsonWithAlert(url, {
      method: 'PATCH',
    })
  },
}
